export const loginUnavailableMessage = 'Bejelentkezés sikertelen, a rendszer nem elérhető. Kérjük próbálja újra később.';

export const getLoginErrorMessage = error => {
  const status = error?.response?.status;
  return status === 401 || status === 403
    ? 'Bejelentkezés sikertelen, a megadott adatok nem megfelelőek.'
    : loginUnavailableMessage;
};
